import React from "react";
import { FaHourglassHalf, FaClock, FaCheckCircle } from "react-icons/fa";


export const makeAssType_23 = ({ book, user }) => ({
    7: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",
            // ===== Short step cards =====
            icon1:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Search & Buy the Product",
            description1: "Use the link below to search & purchase the product. Then click the 'Next Step' button.",

            icon2:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Upload a clear screenshot/photo of your Amazon order. Using the product is up to you.",

            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Search and Purchase the Product directly on Amazon (BuyOut). Reimbursement: +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? book.selectedCurrentUserAssign?.assignment_price_amz ?? 'the product’s retail price'} (w/o delivery)`,
            full_subtitle1: "No public review required. Proof of purchase is mandatory.",
            full_description1: (
                <p>
                    Please purchase the <b>exact Physical Product ASIN</b> listed for this assignment. Do <b>not</b> buy used copies
                    or from third-party sellers. Keep your <b>Order ID</b> handy. Reimbursement covers the product’s retail price
                    <b> excluding delivery costs</b>. Use the button below to open the Amazon page and complete your purchase.
                </p>
            ),

            full_title2: "Upload your purchase proof and product photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, product title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical product you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),



            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Upload proof of purchase",
            description2: "Please upload a clear screenshot or photo of your Amazon order. Using the product is optional.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Upload your purchase proof and product photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, product title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical product you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title3: "Turn in this assignment",
            description3: "You are on the third step now! Click “Turn In” to submit your assignment to start verification process.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title4: "Reimbursement & Virt credit",
            description4: "We received your submission. We’ll verify it and credit upon approval. You’ll be notified soon.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification & reimbursement in progress",
            full_subtitle4: "We’re reviewing your files and confirming order details.",
            full_description4: (
                <>
                    Our team is verifying your purchase with the provided screenshots/photos and Amazon order details.
                    If anything is missing or unclear, we’ll ask you to re-upload the files. Once approved, we will
                    credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b> according
                    to the assignment terms.
                </>
            ),
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.kindle_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "We’ve reviewed and validated your proof — all good, nicely done and confirmed!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Assignment submitted successfully and verified — great job completing it thoroughly and fast!",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Assignment confirmed!",
            description4: "Congratulations, your BuyOut assignment is fully confirmed! Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <p>
                    This BuyOut assignment is now closed. You have received your <b>Virt</b> and reimbursement of the
                    <b> product’s retail price (excluding delivery)</b>. Please note that if verification later reveals
                    discrepancies in your submitted files, adjustments to your balance may still be required.
                    Thank you for completing the assignment!
                </p>
            ),
        },
    },
    8: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",
            // ===== Short step cards =====
            icon1:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Search & Buy the Product",
            description1: "Use the link below to search & purchase the product. Then click the 'Next Step' button.",

            icon2:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Upload a clear screenshot/photo of your Amazon order. Using the product is up to you.",

            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Search and Purchase the Product directly on Amazon (BuyOut). Reimbursement: +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? book.selectedCurrentUserAssign?.assignment_price_amz ?? 'the product’s retail price'} (w/o delivery)`,
            full_subtitle1: "No public review required. Proof of purchase is mandatory.",
            full_description1: (
                <p>
                    Please purchase the <b>exact Physical Product ASIN</b> listed for this assignment. Do <b>not</b> buy used copies
                    or from third-party sellers. Keep your <b>Order ID</b> handy. Reimbursement covers the product’s retail price
                    <b> excluding delivery costs</b>. Use the button below to open the Amazon page and complete your purchase.
                </p>
            ),

            full_title2: "Upload your purchase proof and product photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, product title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical product you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),



            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Upload proof of purchase",
            description2: "Please upload a clear screenshot or photo of your Amazon order. Using the product is optional.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Upload your purchase proof and product photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, product title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical product you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title3: "Turn in this assignment",
            description3: "You are on the third step now! Click “Turn In” to submit your assignment to start verification process.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title4: "Reimbursement & Virt credit",
            description4: "We received your submission. We’ll verify it and credit upon approval. You’ll be notified soon.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification & reimbursement in progress",
            full_subtitle4: "We’re reviewing your files and confirming order details.",
            full_description4: (
                <>
                    Our team is verifying your purchase with the provided screenshots/photos and Amazon order details.
                    If anything is missing or unclear, we’ll ask you to re-upload the files. Once approved, we will
                    credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b> according
                    to the assignment terms.
                </>
            ),
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.paper_back_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "We’ve reviewed and validated your proof — all good, nicely done and confirmed!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Assignment submitted successfully and verified — great job completing it thoroughly and fast!",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Assignment confirmed!",
            description4: "Congratulations, your BuyOut assignment is fully confirmed! Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <p>
                    This BuyOut assignment is now closed. You have received your <b>Virt</b> and reimbursement of the
                    <b> product’s retail price (excluding delivery)</b>. Please note that if verification later reveals
                    discrepancies in your submitted files, adjustments to your balance may still be required.
                    Thank you for completing the assignment!
                </p>
            ),
        },
    },
    9: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",
            // ===== Short step cards =====
            icon1:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Search & Buy the Product",
            description1: "Use the link below to search & purchase the product. Then click the 'Next Step' button.",

            icon2:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Upload a clear screenshot/photo of your Amazon order. Using the product is up to you.",

            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Search and Purchase the Product directly on Amazon (BuyOut). Reimbursement: +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? book.selectedCurrentUserAssign?.assignment_price_amz ?? 'the product’s retail price'} (w/o delivery)`,
            full_subtitle1: "No public review required. Proof of purchase is mandatory.",
            full_description1: (
                <p>
                    Please purchase the <b>exact Physical Product ASIN</b> listed for this assignment. Do <b>not</b> buy used copies
                    or from third-party sellers. Keep your <b>Order ID</b> handy. Reimbursement covers the product’s retail price
                    <b> excluding delivery costs</b>. Use the button below to open the Amazon page and complete your purchase.
                </p>
            ),

            full_title2: "Upload your purchase proof and product photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, product title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical product you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),



            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Upload proof of purchase",
            description2: "Please upload a clear screenshot or photo of your Amazon order. Using the product is optional.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Upload your purchase proof and product photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, product title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical product you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title3: "Turn in this assignment",
            description3: "You are on the third step now! Click “Turn In” to submit your assignment to start verification process.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title4: "Reimbursement & Virt credit",
            description4: "We received your submission. We’ll verify it and credit upon approval. You’ll be notified soon.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification & reimbursement in progress",
            full_subtitle4: "We’re reviewing your files and confirming order details.",
            full_description4: (
                <>
                    Our team is verifying your purchase with the provided screenshots/photos and Amazon order details.
                    If anything is missing or unclear, we’ll ask you to re-upload the files. Once approved, we will
                    credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b> according
                    to the assignment terms.
                </>
            ),
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.hard_cover_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "We’ve reviewed and validated your proof — all good, nicely done and confirmed!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Assignment submitted successfully and verified — great job completing it thoroughly and fast!",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Assignment confirmed!",
            description4: "Congratulations, your BuyOut assignment is fully confirmed! Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <p>
                    This BuyOut assignment is now closed. You have received your <b>Virt</b> and reimbursement of the
                    <b> product’s retail price (excluding delivery)</b>. Please note that if verification later reveals
                    discrepancies in your submitted files, adjustments to your balance may still be required.
                    Thank you for completing the assignment!
                </p>
            ),
        },
    },
    10: {
        STEP1: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",
            // ===== Short step cards =====
            icon1:  <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title1: "Search & Buy the Product",
            description1: "Use the link below to search & purchase the product. Then click the 'Next Step' button.",

            icon2:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Upload a clear screenshot/photo of your Amazon order. Using the product is up to you.",

            icon3:  <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Submit the assignment. Verification will be completed after we review your files.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "After verification, you’ll receive Virt + reimbursement of the product price (excluding delivery).",

            // ===== Expanded step panels =====
            full_title1: `Search and Purchase the Product directly on Amazon (BuyOut). Reimbursement: +$${book.selectedCurrentUserAssign?.book_cost_compensation ?? book.selectedCurrentUserAssign?.assignment_price_amz ?? 'the product’s retail price'} (w/o delivery)`,
            full_subtitle1: "No public review required. Proof of purchase is mandatory.",
            full_description1: (
                <p>
                    Please purchase the <b>exact Physical Product ASIN</b> listed for this assignment. Do <b>not</b> buy used copies
                    or from third-party sellers. Keep your <b>Order ID</b> handy. Reimbursement covers the product’s retail price
                    <b> excluding delivery costs</b>. Use the button below to open the Amazon page and complete your purchase.
                </p>
            ),

            full_title2: "Upload your purchase proof and product photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, product title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical product you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),



            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP2: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15}/>,
            title2: "Upload proof of purchase",
            description2: "Please upload a clear screenshot or photo of your Amazon order. Using the product is optional.",

            icon3: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "We are waiting for you to finish the previous two steps. Then you can turn in this assignment.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "Upload your purchase proof and product photo",
            full_subtitle2: "Make sure both images are clear and readable.",
            full_description2: (
                <p>
                    Please upload a <b>screenshot of your Amazon purchase receipt</b> showing the
                    order ID, product title (or ASIN), order date, price, and your Amazon account name —
                    <b>and a photo of the physical product you received in the Amazon package</b>.
                    Both files must be clear and readable. Blurred or cropped images may be rejected.
                </p>
            ),

            full_title3: "Turn in this assignment",
            full_subtitle3: "Submit after uploading your proof.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP3: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title3: "Turn in this assignment",
            description3: "You are on the third step now! Click “Turn In” to submit your assignment to start verification process.",

            icon4: <FaClock className="text-success position-absolute top-0 end-0 m-2" size={18}/>,
            title4: "Reimbursement & Virt credit",
            description4: "We are waiting for you to finish the previous three steps. Then you’ll receive Virt + reimbursement.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "Turn in this assignment",
            full_subtitle3: "After uploading your proof, please submit this assignment so that our team can begin the verification process.",
            full_description3: (
                <p>
                    Click the button below to submit. Our team will verify the order against Amazon after reviewing your files.
                    If anything is missing, we’ll ask you to re-upload or provide additional details.
                </p>
            ),

            full_title4: "Receive reimbursement & Virt",
            full_subtitle4: "Reimbursement excludes delivery; additional Virt will be credited after approval.",
            full_description4: (
                <p>
                    Once verified, we will credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b>
                    according to the assignment terms. Thanks for completing the BuyOut assignment!
                </p>
            ),
        },
        STEP4: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "Your proof has been successfully uploaded — excellent work completing this step! Keep it up!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Your assignment has been submitted! You’ll be notified once the assignment is complete.",

            icon4: <FaHourglassHalf className="text-success position-absolute top-0 end-0 m-2 animate__animated animate__rotateIn animate__infinite" size={15} />,
            title4: "Reimbursement & Virt credit",
            description4: "We received your submission. We’ll verify it and credit upon approval. You’ll be notified soon.",

            // ===== Expanded step panels =====
            full_title1: "",
            full_subtitle1: "",
            full_description1: "",

            full_title2: "",
            full_subtitle2: "",
            full_description2: "",

            full_title3: "",
            full_subtitle3: "",
            full_description3: "",

            full_title4: "Verification & reimbursement in progress",
            full_subtitle4: "We’re reviewing your files and confirming order details.",
            full_description4: (
                <>
                    Our team is verifying your purchase with the provided screenshots/photos and Amazon order details.
                    If anything is missing or unclear, we’ll ask you to re-upload the files. Once approved, we will
                    credit your <b>Virt</b> and reimburse the <b>product’s retail price (excluding delivery)</b> according
                    to the assignment terms.
                </>
            ),
        },
        STEP5: {
            book_asin: book.selectedCurrentUserAssign?.book?.audio_asin || "Not found",

            // ===== Short step cards =====
            icon1: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title1: "Search & Buy the Product",
            description1: "You have completed this step!",

            icon2: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title2: "Upload proof of purchase",
            description2: "We’ve reviewed and validated your proof — all good, nicely done and confirmed!",

            icon3: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title3: "Turn in this assignment",
            description3: "Assignment submitted successfully and verified — great job completing it thoroughly and fast!",

            icon4: <FaCheckCircle className="text-success position-absolute top-0 end-0 m-2" size={18} />,
            title4: "Assignment confirmed!",
            description4: "Congratulations, your BuyOut assignment is fully confirmed! Virt + reimbursement credited.",

            // ===== Expanded step panels =====
            full_title5: "Congratulations, this assignment is fully confirmed!",
            full_subtitle5: "Your Virt and reimbursement have been successfully credited.",
            full_description5: (
                <p>
                    This BuyOut assignment is now closed. You have received your <b>Virt</b> and reimbursement of the
                    <b> product’s retail price (excluding delivery)</b>. Please note that if verification later reveals
                    discrepancies in your submitted files, adjustments to your balance may still be required.
                    Thank you for completing the assignment!
                </p>
            ),
        },
    },
});
